import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
export var QueryParameterNames = /*#__PURE__*/function () {
  function QueryParameterNames() {
    _classCallCheck(this, QueryParameterNames);
  }

  _createClass(QueryParameterNames, null, [{
    key: "TestHooksParamName",
    get: function get() {
      return "testhooks";
    }
  }, {
    key: "ConnectionIdHeader",
    get: function get() {
      return "X-ConnectionId";
    }
  }, {
    key: "DeploymentIdParamName",
    get: function get() {
      return "cid";
    }
  }, {
    key: "FormatParamName",
    get: function get() {
      return "format";
    }
  }, {
    key: "LanguageParamName",
    get: function get() {
      return "language";
    }
  }, {
    key: "TranslationFromParamName",
    get: function get() {
      return "from";
    }
  }, {
    key: "TranslationToParamName",
    get: function get() {
      return "to";
    }
  }, {
    key: "Profanify",
    get: function get() {
      return "profanity";
    }
  }, {
    key: "EnableAudioLogging",
    get: function get() {
      return "storeAudio";
    }
  }, {
    key: "EnableWordLevelTimestamps",
    get: function get() {
      return "wordLevelTimestamps";
    }
  }, {
    key: "InitialSilenceTimeoutMs",
    get: function get() {
      return "initialSilenceTimeoutMs";
    }
  }, {
    key: "EndSilenceTimeoutMs",
    get: function get() {
      return "endSilenceTimeoutMs";
    }
  }, {
    key: "StableIntermediateThreshold",
    get: function get() {
      return "stableIntermediateThreshold";
    }
  }, {
    key: "StableTranslation",
    get: function get() {
      return "stableTranslation";
    }
  }]);

  return QueryParameterNames;
}();